import { AUTH_FORBIDDEN_MESSAGE } from './auth-forbidden-message.const';
import { isAuthForbidden } from './is-auth-forbidden';

const AUTH_GENERIC_ERROR_MESSAGE = 'Anmeldung fehlgeschlagen';

/** Maps a login/authorization error to the message shown under the login button. */
export function toAuthErrorMessage(error: unknown): string {
  return isAuthForbidden(error) ? AUTH_FORBIDDEN_MESSAGE : AUTH_GENERIC_ERROR_MESSAGE;
}
